import React from 'react';

import { CustomSVGProps } from '@cineamo/ui/src/icons/CustomSVGProps.types';

export default function IconAppLogo(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="app logo">
            <path
                d="M0 9.84615C0 4.40827 4.40827 0 9.84615 0H30.1538C35.5917 0 40 4.40827 40 9.84615V30.1538C40 35.5917 35.5917 40 30.1538 40H9.84615C4.40827 40 0 35.5917 0 30.1538V9.84615Z"
                fill="#000023"
            />
            <path
                d="M0 9.84615C0 4.40827 4.40827 0 9.84615 0H30.1538C35.5917 0 40 4.40827 40 9.84615V30.1538C40 35.5917 35.5917 40 30.1538 40H9.84615C4.40827 40 0 35.5917 0 30.1538V9.84615Z"
                fill="url(#paint0_radial_1824_19653)"
                fillOpacity="0.9"
            />
            <path
                d="M0 9.84615C0 4.40827 4.40827 0 9.84615 0H30.1538C35.5917 0 40 4.40827 40 9.84615V30.1538C40 35.5917 35.5917 40 30.1538 40H9.84615C4.40827 40 0 35.5917 0 30.1538V9.84615Z"
                fill="url(#paint1_radial_1824_19653)"
                fillOpacity="0.9"
            />
            <path
                d="M0 9.84615C0 4.40827 4.40827 0 9.84615 0H30.1538C35.5917 0 40 4.40827 40 9.84615V30.1538C40 35.5917 35.5917 40 30.1538 40H9.84615C4.40827 40 0 35.5917 0 30.1538V9.84615Z"
                fill="url(#paint2_radial_1824_19653)"
                fillOpacity="0.9"
            />
            <path
                d="M0 9.84615C0 4.40827 4.40827 0 9.84615 0H30.1538C35.5917 0 40 4.40827 40 9.84615V30.1538C40 35.5917 35.5917 40 30.1538 40H9.84615C4.40827 40 0 35.5917 0 30.1538V9.84615Z"
                fill="url(#paint3_radial_1824_19653)"
                fillOpacity="0.9"
            />
            <path
                d="M0 9.84615C0 4.40827 4.40827 0 9.84615 0H30.1538C35.5917 0 40 4.40827 40 9.84615V30.1538C40 35.5917 35.5917 40 30.1538 40H9.84615C4.40827 40 0 35.5917 0 30.1538V9.84615Z"
                fill="url(#paint4_radial_1824_19653)"
                fillOpacity="0.9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M30.1538 0.615385H9.84615C4.74814 0.615385 0.615385 4.74814 0.615385 9.84615V30.1538C0.615385 35.2519 4.74814 39.3846 9.84615 39.3846H30.1538C35.2519 39.3846 39.3846 35.2519 39.3846 30.1538V9.84615C39.3846 4.74814 35.2519 0.615385 30.1538 0.615385ZM9.84615 0C4.40827 0 0 4.40827 0 9.84615V30.1538C0 35.5917 4.40827 40 9.84615 40H30.1538C35.5917 40 40 35.5917 40 30.1538V9.84615C40 4.40827 35.5917 0 30.1538 0H9.84615Z"
                fill="#C2C2C2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.8592 7.31946C15.867 7.3279 15.0653 8.13482 15.0653 9.12905V13.7242C15.0653 12.4429 16.3603 11.5674 17.5494 12.0449L19.4808 12.8208L32.9515 18.4101C33.4295 18.6069 33.8861 18.0875 33.6295 17.6387L28.2537 8.23118C27.9343 7.67204 27.342 7.3252 26.6989 7.31946H16.8592Z"
                fill="url(#paint5_linear_1824_19653)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.2894 7.31946C13.6463 7.3252 13.0541 7.67204 12.7345 8.23109L11.8767 9.73235L6.53009 19.089C6.21214 19.6453 6.21214 20.3283 6.53009 20.8847L11.0901 28.8464C11.5418 29.6371 12.5107 29.9689 13.3524 29.621L16.2596 28.4197L17.3858 27.9571C16.2465 28.2966 15.0653 27.4459 15.0653 26.2217V23.6061V9.12905C15.0653 8.13482 15.8669 7.3279 16.8591 7.31946H14.2894Z"
                fill="url(#paint6_linear_1824_19653)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.6295 22.335L28.2537 31.7425C27.9316 32.3063 27.332 32.6543 26.6825 32.6543H14.3058C13.6563 32.6543 13.0568 32.3064 12.7346 31.7425L11.8767 30.2414L11.0901 28.8465C11.5418 29.6371 12.5108 29.9689 13.3523 29.6211L16.2596 28.4198L32.9515 21.5636C33.4295 21.3668 33.886 21.8862 33.6295 22.335Z"
                fill="#00FFDC"
            />
            <defs>
                <radialGradient
                    id="paint0_radial_1824_19653"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(38.8267 40.3695) rotate(-116.343) scale(44.4703 71.846)">
                    <stop stopColor="#3815C2" />
                    <stop
                        offset="1"
                        stopColor="#3815C2"
                        stopOpacity="0.49"
                    />
                </radialGradient>
                <radialGradient
                    id="paint1_radial_1824_19653"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(6.86111 33.3008) rotate(-37.7276) scale(25.3043 42.3781)">
                    <stop
                        offset="0.345246"
                        stopColor="#18185F"
                    />
                    <stop
                        offset="1"
                        stopColor="#1E1E41"
                        stopOpacity="0"
                    />
                </radialGradient>
                <radialGradient
                    id="paint2_radial_1824_19653"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(38.9867 0.640394) rotate(42.1729) scale(54.2601 34.59)">
                    <stop stopColor="#29D798" />
                    <stop
                        offset="0.308137"
                        stopColor="#29D798"
                        stopOpacity="0.61"
                    />
                    <stop
                        offset="1"
                        stopColor="#18AB76"
                        stopOpacity="0"
                    />
                </radialGradient>
                <radialGradient
                    id="paint3_radial_1824_19653"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(4.5625 0.387324) rotate(56.6834) scale(41.2799 51.1092)">
                    <stop stopColor="#610769" />
                    <stop
                        offset="0.156083"
                        stopColor="#5A0662"
                        stopOpacity="0.781367"
                    />
                    <stop
                        offset="1"
                        stopColor="#410247"
                        stopOpacity="0"
                    />
                </radialGradient>
                <radialGradient
                    id="paint4_radial_1824_19653"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(20 29.2773) rotate(-86.8059) scale(17.449 17.6532)">
                    <stop
                        stopColor="#35008F"
                        stopOpacity="0.47"
                    />
                    <stop
                        offset="1"
                        stopColor="#35008F"
                        stopOpacity="0"
                    />
                </radialGradient>
                <linearGradient
                    id="paint5_linear_1824_19653"
                    x1="39.975"
                    y1="10.625"
                    x2="28.0418"
                    y2="-2.81909"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00FFDC" />
                    <stop
                        offset="0.490223"
                        stopColor="#00FFDC"
                    />
                    <stop
                        offset="1"
                        stopColor="#00AAA0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_1824_19653"
                    x1="6.48895"
                    y1="7.31946"
                    x2="6.48895"
                    y2="28.9603"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00FFDC" />
                    <stop
                        offset="0.509799"
                        stopColor="#00FFDC"
                    />
                    <stop
                        offset="1"
                        stopColor="#00AAA0"
                    />
                </linearGradient>
            </defs>
        </svg>
    );
}
